import { Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateEnum } from 'src/app/core/enums/date.enum';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { DateManager } from 'src/app/core/managers/date.manager';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { Utils } from 'src/app/core/resources/utils';
import { CargoService } from 'src/app/core/services/cargo.service';
import { GoogleService } from 'src/app/core/services/google.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { AddressCargo } from 'src/app/core/interfaces/addressCargo';
import { DatePipe } from '@angular/common';
import { ConsignmentCargo } from 'src/app/core/interfaces/consignmentCargo';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';
import {
  DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE,
  isDocumentRecreationInProgress
} from 'src/app/core/resources/transport-company-change.utils';

const after = (date: Date): ValidatorFn => {
  return (control: AbstractControl) => {
    return control && control.value && date && DateManager.isSameOrBefore(control.value, date, 'seconds') ? { "minDate": date } : {};
  }
}
const before = (date: Date): ValidatorFn => {
  return (control: AbstractControl) => {
    return control && control.value && date && !DateManager.isSameOrBefore(control.value, date, 'seconds') ? { "maxDate": date } : {};
  }
}
@Component({

  selector: 'app-end-cargo-check',
  templateUrl: './end-cargo-check.component.html',
  styleUrls: ['./end-cargo-check.component.scss'],
  providers: [DateFormatPipe, DatePipe]
})
export class EndCargoCheckComponent {

  public currentDate = new Date();
  form: FormGroup;
  isFormCreated = false;
  cargoConsignments: { [key: string]: ConsignmentCargo } = {};
  lastAddressOrigin: AddressCargo;
  readonly documentRecreationInProgressMessage = DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE;
  constructor(
    public dialogRef: MatDialogRef<EndCargoCheckComponent>,
    @Inject(MAT_DIALOG_DATA) public cargo: Cargo,
    private spinner: NgxSpinnerService,
    public snackBarService: SnackBarService,
    private _cargoService: CargoService,
    private cargoDetailService: CargoDetailService,
    public dialog: MatDialog,
    public utils: Utils,
    public cargoManager: CargoManager,
    private datePipe: DatePipe
  ) {
    this.initializeForm();
  }

  private async initializeForm() {
    await this.getCargoConsignments();
    this.form = new FormGroup({
      //origin: new FormGroup({}),
      destinations: new FormGroup({})
    });

    // Origin
    /*const origin_form = (this.form.get('origin') as FormGroup);
    const origin = this.cargo.cargoFeature.uploadDownload.origin.addresses;
    for (const i in origin) {
      const address = origin[i];
      const start = address.durationTime && address.durationTime.startDate ?
        moment(address.durationTime.startDate) : null;
      const end = address.durationTime && address.durationTime.endDate ?
        moment(address.durationTime.endDate) : null;

      origin_form.addControl(`startDate_${i}`, new FormControl(start));
      origin_form.addControl(`endDate_${i}`, new FormControl(end));
    }*/

    // Destination
    const destinations_form = (this.form.get('destinations') as FormGroup);
    const destinations = this.cargo.cargoFeature.uploadDownload.destination;
    this.lastAddressOrigin = this.cargo.cargoFeature.uploadDownload.origin.addresses[this.cargo.cargoFeature.uploadDownload.origin.addresses.length - 1];
    for (const i in destinations) {
      const destination = destinations[i];
      const destination_form = new FormGroup({});

      for (const j in destination.addresses) {
        const address = destination.addresses[j];
        if (!address.consignments || !address.consignments.length) continue;
        for (const [k, consignment] of address.consignments.entries()) {
          const consignmentCargo = this.cargoConsignments[consignment];
          const downloadDate = consignmentCargo && consignmentCargo.unload && consignmentCargo.unload.date
            ? this.cargoManager.getRealDate(DateManager.formatDate(consignmentCargo.unload.date, 'DD/MM/YYYY'), consignmentCargo.unload.appointmentTime)
            : this.cargoManager.getRealDate(destination.downloadDate, address.time);
          const hasStartDate = address.durationTime && address.durationTime.startDate;
          const dateStart = hasStartDate ? address.durationTime.startDate : DateManager.dateToString(downloadDate);
          const minDownloadDate = consignmentCargo && consignmentCargo.load && consignmentCargo.load.date
            ? this.cargoManager.getDepartureDate(consignmentCargo.load.appointmentTime, consignmentCargo.load.hours, consignmentCargo.load.minutes, DateManager.formatDate(consignmentCargo.load.date, 'DD/MM/YYYY'))
            : this.cargoManager.getDepartureDate(this.lastAddressOrigin.time, this.lastAddressOrigin.timePact, this.lastAddressOrigin.minutePact, this.cargo.dateLoad);
          const hasEndDate = address.durationTime && address.durationTime.endDate && DateManager.isSameOrBefore(DateManager.stringToDate(dateStart), DateManager.stringToDate(address.durationTime.endDate));
          const dateEnd = hasEndDate ? address.durationTime.endDate : dateStart;

          destination_form.addControl(`minDate_${i}_${j}_${k}`, new FormControl({ value: downloadDate, disabled: true }));
          destination_form.addControl(`startDate_${i}_${j}_${k}`, new FormControl({ value: DateManager.stringToDate(dateStart), disabled: true }));
          destination_form.addControl(`endDate_${i}_${j}_${k}`, new FormControl({ value: DateManager.stringToDate(dateEnd), disabled: true }));
          destination_form.addControl(`realDate_${i}_${j}_${k}`, new FormControl(
            { value: new Date(hasStartDate ? dateStart : downloadDate), disabled: !!address.approvalInitialConsignment },
            [/*after(new Date(minDownloadDate))*/, before(this.currentDate), Validators.required]
          ));
          destination_form.addControl(`minDateAllowed_${i}_${j}_${k}`, new FormControl(minDownloadDate));
        }
      }

      destinations_form.addControl(`destination_${i}`, destination_form);
    }
    this.isFormCreated = true;
  }

  private async getCargoConsignments() {
    let consignments: ConsignmentCargo[] = [];
    try { consignments = await this.cargoDetailService.getCargoConsignments(this.cargo.id, 'Created').toPromise() } catch (error) { }
    if (!consignments || !consignments.length) return this.cargoConsignments = {};
    consignments.forEach(consignment => {
      this.cargoConsignments[consignment.id] = consignment;
    });
  }

  getDownloadDate(indexCity, indexDestination): string {
    const destinations = this.cargo.cargoFeature.uploadDownload.destination;
    return DateManager.formatDate(destinations[indexCity].downloadDate, DateEnum.YYYY_MM_DD).substring(0, 10) + ' ' + destinations[indexCity].addresses[indexDestination].time;
  }

  public onSubmit(_event: Event): void {
    _event.preventDefault();
    _event.stopPropagation();
    if (this.documentRecreationInProgress) {
      this.snackBarService.openSnackBar(
        this.documentRecreationInProgressMessage,
        undefined,
        'alert'
      );
      return;
    }
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      if (!this.findErrorOnDestinations())
        this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'alert');
      return;
    }

    let consignments = {
      cargoId: this.cargo.id,
      consignment: []
    };
    const destinations = this.cargo.cargoFeature.uploadDownload.destination;
    const destinations_form = (this.form.get('destinations') as FormGroup);
    for (const [i, destination] of destinations.entries()) {
      for (const [j, address] of destination.addresses.entries()) {
        if (!address.consignments || !address.consignments.length) continue;
        for (const [k, consignment] of address.consignments.entries()) {
          consignments.consignment.push({
            id: consignment,
            dateTimeDownload: DateManager.dateToString(destinations_form.get(`destination_${i}.realDate_${i}_${j}_${k}`).value),
            destinationId: i,
            addressId: j
          });
        }
      }
    }
    this.spinner.show();
    this._cargoService
      .initialFulfillConsignment(consignments)
      .subscribe((success: Array<{ error?: string }>) => {
        this.spinner.hide();
        const errors = success.filter((v) => v.error);

        if (errors.length > 0) {
          this.showResponseInitialFulfill('Error', errors[0].error);
        } else {
          this.showResponseInitialFulfill('Success');
        }
      }, (error) => {
        this.spinner.hide();
        this.showResponseInitialFulfill('Error', error.error);
      });
  }

  findErrorOnDestinations(): boolean {
    let haveErrors = false;
    const destinations = this.cargo.cargoFeature.uploadDownload.destination;
    const destinations_form = (this.form.get('destinations') as FormGroup);
    for (const i in destinations) {
      const destination = destinations[i];
      for (const j in destination.addresses) {
        const address = destination.addresses[j];
        if (!address.consignments || !address.consignments.length) continue;
        for (const k in address.consignments) {
          if (!haveErrors && destinations_form.get(`destination_${i}.realDate_${j}_${k}`) && destinations_form.get(`destination_${i}.realDate_${j}_${k}`).errors) {
            haveErrors = true;
            if (destinations_form.get(`destination_${i}.realDate_${j}_${k}`).errors.minDate)
              this.snackBarService.openSnackBar(`La fecha de llegada al descargue ${parseInt(i) + 1} dirección ${parseInt(j) + 1} debe ser superior a ${DateManager.dateToString(destinations_form.get(`destination_${i}.realDate_${j}_${k}`).errors.minDate, 'YYYY-MM-DD HH:mm a')}`, undefined, 'alert');
            if (destinations_form.get(`destination_${i}.realDate_${j}_${k}`).errors.maxDate)
              this.snackBarService.openSnackBar(`La fecha de llegada al descargue ${parseInt(i) + 1} dirección ${parseInt(j) + 1} no puede ser mayor a la fecha actual`, undefined, 'alert');
            else this.utils.errorMessagesCustomized(destinations_form.get(`destination_${i}.realDate_${j}_${k}`), `fecha de llegada al descargue ${parseInt(i) + 1} dirección ${parseInt(j) + 1}`);
            break;
          }
        }
      }
      if (haveErrors) break;
    }
    return haveErrors;
  }

  private showResponseInitialFulfill(type: 'Success' | 'Error', message?: string) {
    const dialogConfig = new MatDialogConfig();
    let title = '';
    if (type == 'Success') {
      title = `Cumplido inicial generado correctamente para el servicio ${this.cargo.consecutive}`;
    } else {
      title = `Ocurrió un error al realizar el cumplido inicial del servicio ${this.cargo.consecutive}`;
    }
    dialogConfig.data = {
      title,
      icon: type === 'Success',
      iconError: type === 'Error',
      hideBtnCancel: true,
      description: type === 'Error' ? message : null
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const _modal = this.dialog.open(DialogComponent, dialogConfig);
    _modal.afterClosed().subscribe({
      next: () => {
        if (type === 'Success') {
          this.dialogRef.close(this.cargo);
        }
      }
    });
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, "d MMMM yyyy, h:mm a");
  }

  get documentRecreationInProgress(): boolean {
    return isDocumentRecreationInProgress(this.cargo);
  }

}
